/**
 * Pedido já vendido: depois do primeiro pagamento (total ou parcial) ou de virar evento programado, o carrinho do cliente
 * não pode mais regravar valores, frete, itens ou convidados. MAR-321A foi pago em R$ 4.625,50 e, ao reabrir a loja no
 * celular, a sincronização do carrinho recalculou o frete sem o pedágio e gravou R$ 4.584,90 por cima do pedido pago.
 * Mudanças depois da venda só pelo fornecedor/painel (convidados e horas adicionais viram cobrança adicional).
 */
const PAID_PAYMENT_STATUSES = ['paid', 'partially_paid'];
const SOLD_STATUSES = ['programado', 'em preparacao', 'a caminho', 'saiu para entrega', 'entregue', 'finalizado'];

const normalize = (value: unknown): string =>
  String(value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();

export const isOrderLockedForCart = (order: { status?: string | null; status_payments?: string | null } | null | undefined): boolean => {
  if (!order) return false;
  if (PAID_PAYMENT_STATUSES.includes(normalize(order.status_payments))) return true;
  return SOLD_STATUSES.includes(normalize(order.status));
};
